import { render, staticRenderFns } from "./YesNoButtons.vue?vue&type=template&id=b653adc8&"
import script from "./YesNoButtons.vue?vue&type=script&lang=js&"
export * from "./YesNoButtons.vue?vue&type=script&lang=js&"
import style0 from "./YesNoButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports